import { Permissions, User } from "@cnx/common";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { guardedLocalStorage } from "../utils/persistentStorage";

export interface AuthState {
  currentUserId?: string;
  avatar?: string;
  email?: string;
  fullName?: string;
  isOffline?: boolean;
  token?: string;
  selectedUser?: User;
  expiresAt?: string;
  useRights: Permissions[];
  setCurrentUserId: (currentUserId: string) => void;
  setEmail: (email: string) => void;
  setIsOffline: (isOffline: boolean) => void;
  setToken: (token?: string) => void;
  setSelectedUser: (user: User) => void;
  setUseRights: (useRights: Permissions[]) => void;
  setExpiresAt: (expiresAt: string) => void;
  setAvatar: (avatar: string) => void;
  setFullName: (fullName: string) => void;
  reset: () => void;
}

const initialState = {
  currentUserId: "",
  avatar: "",
  email: "",
  fullName: "",
  token: "",
  selectedUser: undefined,
  expiresAt: "",
  useRights: [],
};

export const useAuthStore = create<AuthState>()(
  persist(
    set => ({
      ...initialState,
      setCurrentUserId: currentUserId => set({ currentUserId }),
      setEmail: email => set({ email }),
      setFullName: fullName => set({ fullName }),
      setIsOffline: isOffline => set({ isOffline }),
      setToken: token => set({ token }),
      setSelectedUser: selectedUser => set({ selectedUser }),
      setUseRights: useRights => set({ useRights }),
      setExpiresAt: expiresAt => set({ expiresAt }),
      setAvatar: avatar => set({ avatar }),
      reset: () => set({ ...initialState }),
    }),
    {
      name: "authStore",
      storage: createJSONStorage(() => guardedLocalStorage),
      partialize: ({ isOffline, ...whiteList }) => {
        return whiteList;
      },
    }
  )
);
